import React from 'react';

import { ModalProps } from '../../../../components/Modal';
import { SimpleModal } from '../../../../components/SimpleModal';
import { Button } from '../../../../components';

import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';

type ModalTypeProps = { handleOpeningScheduleModule: () => void } & Pick<ModalProps, 'visible' | 'onClose'>;

export const ModalAlreadyScheduled: React.FC<ModalTypeProps> = ({ visible, onClose, handleOpeningScheduleModule }) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Você já possui um agendamento para esse serviço"
      subtitle="Para consultar, reagendar ou cancelar o seu agendamento clique no botão abaixo."
      mainIcon={<WarningModal />}
      customFooterContainer={
        <>
          <Button
            disabled={!visible}
            type="button"
            title="Consultar agendamentos"
            onClick={handleOpeningScheduleModule}
          />
          <Button disabled={!visible} tertiary type="button" title="Fechar" onClick={onClose} />
        </>
      }
    />
  );
};
